export default "__VITE_ASSET__CqqZvUND__"